export const FUTURE_TRADES_CHANGED_EVENT = "future-trades-changed";
export const POSITION_CREATED_EVENT = "position-created";
export const POSITION_UPDATED_EVENT = "position-updated";

export function notifyFutureTradesChanged(detail = {}) {
  if (typeof window === "undefined") return;
  window.dispatchEvent(
    new CustomEvent(FUTURE_TRADES_CHANGED_EVENT, { detail })
  );
}

export function notifyPositionCreated(detail = {}) {
  if (typeof window === "undefined") return;
  window.dispatchEvent(new CustomEvent(POSITION_CREATED_EVENT, { detail }));
  // Also trigger the general futures-changed so existing listeners refresh
  window.dispatchEvent(new CustomEvent(FUTURE_TRADES_CHANGED_EVENT, { detail }));
}

export function notifyPositionUpdated(detail = {}) {
  if (typeof window === "undefined") return;
  window.dispatchEvent(new CustomEvent(POSITION_UPDATED_EVENT, { detail }));
  window.dispatchEvent(new CustomEvent(FUTURE_TRADES_CHANGED_EVENT, { detail }));
}
